import { HomeCity } from '../../domain/entities/HomeContentEntity';

export interface NextImageVM {
  src: string;
  width: number;
  height: number;
  alt: string;
}

export const ARROW_ICON: NextImageVM = {
  src: 'https://dom-content-vault-prod-cdn-assets.porter.in/right_arrow_13ec096466/right_arrow_13ec096466.svg',
  width: 24,
  height: 24,
  alt: 'arrow icon',
};

export function getCurrentCityData(
  all_cities: HomeCity[],
  current_city: string,
): HomeCity | undefined {
  const target = current_city.toLowerCase();
  return all_cities.find((city) => city.city_name.toLowerCase() === target);
}
